import { ValidationError } from "yup";

export const parseYupErrors = (
  error: ValidationError
): Record<string, string> => {
  const errors: Record<string, string> = {};
  if (error.inner) {
    error.inner.forEach((err) => {
      if (err.path) {
        errors[err.path] = err.message;
      }
    });
  }
  return errors;
};

export const clearFieldError = <T extends Record<string, string>>(
  errors: T,
  field: string
): T => {
  if (!errors[field]) {
    return errors;
  }
  const newErrors = { ...errors };
  delete newErrors[field];
  return newErrors;
};
